const CONTENT_HOVER_ANIMATIONS = {
  NO_EFFECT: 'NO_EFFECT',
  ZOOM_IN: 'ZOOM_IN',
  TILT: 'TILT',
  BLUR: 'BLUR',
  GRAYSCALE: 'GRAYSCALE',
  SHRINK: 'SHRINK',
  INVERT: 'INVERT',
  COLOR_IN: 'COLOR_IN',
  DARKENED: 'DARKENED',
  MAIN_COLOR: 'MAIN_COLOR',
};

export default CONTENT_HOVER_ANIMATIONS;
